/**
 * Created by Administrator on 2018/1/11 0011.
 */
let Tool = {
  /**
   *
   * @param container 外层容器
   * @param target    目标元素
   * @returns {*}
   */
  contains (container, target) {
    if (container === undefined) { return }
    let _this = container
    let childList = Array.from(_this.children)
    if (childList instanceof Array && childList.length > 0) {
      for (let i = 0; i < childList.length; i++) {
        if (childList[i] === target) {
          return true
        } else {
          let value = this.contains(childList[i], target)
          if (value) {
            return value
          } else {
            continue
          }
        }
      }
    } else {
      if (_this === target) {
        return true
      }
    }
  },
  /**
   * 验证浏览版本
   */
  validBrowserVer () {
    let userAgent = navigator.userAgent
    if (userAgent.includes('MSIE 9.0') || userAgent.includes('MSIE 8.0')) {
      let parent = document.createElement('div')
      parent.className = 'z-alter_warn'
      parent.innerHTML = '<span>你的浏览器太老了，请升级浏览器版本！</span><a href="http://browsehappy.com" target="_blank">立即升级</a>'
      document.body.appendChild(parent)
      return false
    } else {
      return true
    }
  }
}
export default{
  install (Vue) {
    Vue.prototype.Tool = Tool
  }
}



// WEBPACK FOOTER //
// ./src/utils/tool.js